export default function MfGridFunctionalCoreConfig(configOptions) {
  const { filter, client_id } = configOptions

  const title = configOptions.title || null
  const titleNoSpace = configOptions.title || titleNoSpace

  const convertToFilterDefaults = filters => {
    const filterDefaults = []
    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        const value = filters[key]
        // let operator = typeof value === 'number' || typeof value === 'boolean' ? '=' : '='
        const operator = '='
        const filterDefault = [key, operator, filters[key]]
        filterDefaults.push(filterDefault)
      }
    }
    /* CLIENT ADMIN
      if client_id is not null, add it to the filterDefaults.
    */
    if (configOptions.client_id) {
      filterDefaults.client_id = configOptions.client_id
    }
    /* END CLIENT ADMIN  */
    return filterDefaults
  }

  const finalFilters = convertToFilterDefaults(configOptions.filter)

  const columns = configOptions.columns || []

  let titleLowerCase = ''
  let titleUpperCase = ''
  if (title) {
    titleUpperCase = title.toUpperCase()
    titleLowerCase = title.toLowerCase()
  }

  // Adds the grid header class to the grids (to centralize the header text)
  columns.forEach(column => {
    // Check if cssClass property exists and contains other classes
    if (column.cssClass && column.cssClass !== 'devex-column-vertical-align header-align-center') {
      // Keep the existing classes and add the required ones
      column.cssClass += ' devex-column-vertical-align header-align-center'
    } else if (!column.cssClass) {
      // If cssClass doesn't exist, add the required classes
      column.cssClass = 'devex-column-vertical-align header-align-center'
    }
  })

  return {
    columns,
    filter: finalFilters,
    titleLowerCase,
    titleUpperCase
  }
}

export const dataGridDefaultProps = (title, options = {}) => {
  // optionally add seedKey to ensure a unique key in localStorage
  const seedKey = options.seedKey ? options.seedKey : ''
  return {
    allowColumnResizing: true,
    autoNavigateToFocusedRow: false,
    dataKey: 'id',
    datagrid: {
      allowColumnResizing: true,
      allowSorting: true,
      hoverStateEnabled: true,
      id: `${title}DataGrid${seedKey}`,
      rowAlternationEnabled: true,
      showBorders: options.showBorders ? true : false
    },
    defaultPageSize: 10,
    editing: false,
    editingOptions: {
      allowAdding: true,
      allowDeleting: true,
      allowUpdating: true
    },
    errorRowEnabled: false,
    exportButton: {
      fileName: title,
      tabName: title,
      visible: false
    },
    focusedRowEnabled: true,
    hoverStateEnabled: true,
    id: `dataGrid${seedKey}`,
    idSortOrder: 'desc',
    key: `${title}DataGridKey${seedKey}`,
    keyExpr: 'id',
    pager: {
      allowedPageSizes: [10, 25, 50, 100],
      displayMode: 'full',
      showInfo: true,
      showNavigationButtons: true,
      showPageSizeSelector: true,
      visible: true
    },
    showToolbar: false,
    showRowContextMenu: true,
    // stateStoring: [
    //   {
    //     enabled: true,
    //     storageKey: `mfGrid${title}${seedKey}`,
    //     type: 'localStorage',
    //   },
    // ],
    title
  }
}
